<template lang="pug">
    footer This site is not affiliated with Grinding Gear Games in any way. Created by
        a(href="mailto:simone@duiker101.net") Duiker101
</template>

<script>
    export default {
        name: "my-footer"
    }
</script>

<style lang="scss" scoped>
    footer {
        position: absolute;
        right: 0;
        bottom: 0;
        color: white;
        font-size: 10px;
        a{
            color: #fc0;
            margin-left: 0.5em;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/MyFooter.vue